import { word } from "@/modules/core/utils/i18n"
import { cn } from "@/modules/lib/utils"
import { useCurrentBox } from "@modules/box/hooks/useBox"
import { BoxStaffPermissions } from "@modules/boxStaff/gateway/boxStaffDto"
import { useBoxStaffPermission } from "@modules/boxStaff/hooks/useBoxStaffPermissions"
import { useTransactionDetails } from "@modules/finances/hooks/useFinance"
import { TransactionDetailsContainer } from "@modules/finances/transactions/components/transactionDetailsContainer"
import { ApiFinanceType } from "@modules/finances/types/financesType"
import { HuAvatarCardSidebar } from "@modules/ui/components/huAvatarCardSidebar"
import { useMemo } from "react"

type TransactionsDetailsProps = {
  transactionId: string
} & React.ComponentProps<"div">

export function BoxTransactionsDetailsLayout({ transactionId, className, ...props }: TransactionsDetailsProps) {
  const { data: transactionDetails } = useTransactionDetails(transactionId)
  const { result: box } = useCurrentBox()
  const canSeeMembers = useBoxStaffPermission(BoxStaffPermissions.SEE_MEMBERS)

  const contactIsVisible = useMemo(() => {
    if (box === null) return true
    else return canSeeMembers
  }, [box, canSeeMembers])

  return (
    <div className={cn("h-full", className)} {...props}>
      <>
        {transactionDetails.user ? (
          <HuAvatarCardSidebar
            id={transactionDetails.user.id}
            avatar={transactionDetails.user.avatar ?? undefined}
            firstname={transactionDetails.user.firstname}
            lastname={transactionDetails.user.lastname}
            username={transactionDetails.user.username}
            prefixUsername={transactionDetails.user.username ? "@" : undefined}
            email={transactionDetails.user.email}
            canUseContact={contactIsVisible}
          />
        ) : (
          <HuAvatarCardSidebar
            firstname={word("global.text.anonymous")}
            lastname={""}
            prefixUsername={word("global.text.manualAddition")}
            canUseContact={false}
          />
        )}

        <TransactionDetailsContainer transactionDetails={transactionDetails} apiFinanceType={ApiFinanceType.BOX} />
      </>
    </div>
  )
}
